// components/Login.js
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import "../styles/Login.css";

function Login() {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    setError("");

    // Basic form validation
    if (!username || !password) {
      setError("用户名和密码不能为空");
      return;
    }

    setLoading(true);

    try {
      // Simulate a login API call
      const response = await fakeLoginApi(username, password);
      const token = response.token; // Assuming the response contains a token

      login(token); // Save token to localStorage and update auth state
      navigate("/"); // Redirect to home page after login
    } catch (err) {
      setError("登录失败，请检查用户名和密码");
    } finally {
      setLoading(false);
    }
  };

  // Simulated login API function
  const fakeLoginApi = (username, password) => {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        if (username === "sendoAdmin" && password === "czsendo8818.") {
          resolve({ token: "fake-jwt-token" }); // Simulate a successful login
        } else {
          reject(new Error("Invalid credentials")); // Simulate a failed login
        }
      }, 1000); // Simulate network delay
    });
  };

  return (
    <div className="login-container">
      <h2>登录</h2>
      {error && <p className="error-message">{error}</p>}
      <form onSubmit={handleLogin} className="login-form">
        <div className="form-group">
          <label htmlFor="username">用户名</label>
          <input
            type="text"
            id="username"
            placeholder="请输入用户名"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            required
          />
        </div>
        <div className="form-group">
          <label htmlFor="password">密码</label>
          <input
            type="password"
            id="password"
            placeholder="请输入密码"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
        </div>
        <button type="submit" disabled={loading} className="login-button">
          {loading ? "登录中..." : "登录"}
        </button>
      </form>
    </div>
  );
}

export default Login;
